import React, { useEffect } from 'react';
import LandingPage from './components/landingpage/LandingPage';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import UserCompanyRegistration from "./components/userCompanyRegistration/UserCompanyRegistration.jsx";
import Login from './components/login/Login.jsx';
import UserDashboard from './components/userDashboard/UserDashboard.jsx';
import DashboardPage from './components/userDashboard/pages/Dashboard.jsx';
import TestsPage from './components/userDashboard/pages/Tests.jsx';
import ResultsPage from './components/userDashboard/pages/Results.jsx';
import JobsPage from './components/userDashboard/pages/Jobs.jsx';
import LeaderboardPage from './components/userDashboard/pages/Leaderboard.jsx';
import AchievementsPage from './components/userDashboard/pages/Achievements.jsx';
import ProfilePage from './components/userDashboard/pages/Profile.jsx';
import SavedTestsPage from './components/userDashboard/pages/SavedTests.jsx';
import TestDetailPage from './components/userDashboard/pages/TestDetail.jsx';
import CompanyDashboard from './components/companyDashboard/CompanyDashboard.jsx';
import CompanyDashboardPage from './components/companyDashboard/pages/Dashboard.jsx';
import CompanyTestPostsPage from './components/companyDashboard/pages/TestPosts.jsx';
import CompanyCreateTestPage from './components/companyDashboard/pages/CreateTest.jsx';
import CompanyCandidatesPage from './components/companyDashboard/pages/Candidates.jsx';
import CompanyRankingsPage from './components/companyDashboard/pages/Rankings.jsx';
import CompanyMessagesPage from './components/companyDashboard/pages/Messages.jsx';
import CompanySettingsPage from './components/companyDashboard/pages/Settings.jsx';
import { ThemeProvider } from './components/ThemeContext.js';
import { AuthProvider } from './context/AuthContext.js';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import AccountActivation from './components/accountActivation/AccountActivation.jsx';

const GoogleAuthHandler = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const accessToken = params.get('access');
    const refreshTokenParam = params.get('refresh');
    const userRole = params.get('role');
    const userEmail = params.get('email');

    if (accessToken) {
      document.cookie = `access_token=${accessToken}; path=/; SameSite=Lax`;
    }
    if (refreshTokenParam) {
      document.cookie = `refresh_token=${refreshTokenParam}; path=/; SameSite=Lax`;
    }

    if (userEmail) {
      const userData = { email: userEmail, role: userRole };
      localStorage.setItem('user', JSON.stringify(userData));
    }

    if (accessToken || (accessToken && refreshTokenParam)) {
      window.location.href = '/dashboard';
    }
  }, [location]);

  return null;
};

const App = () => {
  return (
    <AuthProvider>
      <ThemeProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/register" element={<UserCompanyRegistration />} />
            <Route path="/login" element={<Login />} />
            <Route path="/activate/:uidb64/:token/" element={<AccountActivation />} />
            <Route path="/auth/google/callback" element={<GoogleAuthHandler />} />

            <Route
              path="/dashboard"
              element={
                <ProtectedRoute allowedRoles={['CANDIDATE']}>
                  <UserDashboard />
                </ProtectedRoute>
              }
            >
              <Route index element={<DashboardPage />} />
              <Route path="tests" element={<TestsPage />} />
              <Route path="results" element={<ResultsPage />} />
              <Route path="jobs" element={<JobsPage />} />
              <Route path="leaderboard" element={<LeaderboardPage />} />
              <Route path="achievements" element={<AchievementsPage />} />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="saved-tests" element={<SavedTestsPage />} />
              <Route path="test/:pk" element={<TestDetailPage />} />
            </Route>

            <Route
              path="/company"
              element={
                <ProtectedRoute allowedRoles={['COMPANY']}>
                  <CompanyDashboard />
                </ProtectedRoute>
              }
            >
              <Route index element={<CompanyDashboardPage />} />
              <Route path="testposts" element={<CompanyTestPostsPage />} />
              <Route path="createtest" element={<CompanyCreateTestPage />} />
              <Route path="candidates" element={<CompanyCandidatesPage />} />
              <Route path="rankings" element={<CompanyRankingsPage />} />
              <Route path="messages" element={<CompanyMessagesPage />} />
              <Route path="settings" element={<CompanySettingsPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </AuthProvider>
  );
};

export default App;
